/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable @typescript-eslint/no-explicit-any */
const DatosBasicos = ({ setForm, form }: any) => {
  const datos = [
    {
      quantity: 1,
      name: "Viajeros",
      nameType: "travellers",
    },
    {
      quantity: 1,
      name: "Baños",
      nameType: "bathrooms",
    },
    {
      quantity: 1,
      name: "Camas",
      nameType: "beds",
    },
    {
      quantity: 1,
      name: "Dormitorios",
      nameType: "bedrooms",
    },
  ];

  const onClick = (e: any, value: any) => {
    console.log(value);
    switch (e.target.name) {
      case "mas-Dormitorios":
        {
          return setForm({
            ...form,
            bedrooms: form.bedrooms + 1,
          });
        }
        break;
      case "mas-Camas":
        {
          return setForm({
            ...form,
            beds: form.beds + 1,
          });
        }
        break;
      case "mas-Baños":
        {
          return setForm({
            ...form,
            bathrooms: form.bathrooms + 1,
          });
        }
        break;
      case "mas-Viajeros":
        {
          return setForm({
            ...form,
            travellers: form.travellers + 1,
          });
        }
        break;
      case "menos-Dormitorios":
        {
          if (form.bedrooms == 0) {
            return "";
          }
          return setForm({
            ...form,
            bedrooms: form.bedrooms - 1,
          });
        }
        break;
      case "menos-Camas":
        {
          if (form.beds == 0) {
            return "";
          }
          return setForm({
            ...form,
            beds: form.beds - 1,
          });
        }
        break;
      case "menos-Baños":
        {
          if (form.bathrooms == 0) {
            return "";
          }
          return setForm({
            ...form,
            bathrooms: form.bathrooms - 1,
          });
        }
        break;
      case "menos-Viajeros": {
        if (form.travellers == 0) {
          return "";
        }
        return setForm({
          ...form,
          travellers: form.travellers - 1,
        });
      }
      default:
        break;
    }
  };
  return (
    <div className="h-[100%] flex justify-center items-center">
      <div className="grid lg:grid-cols-1 gap-10 py-5 px-5">
        <div>
          <span className="font-bold text-black mb-2 block">
            ¿Agregá algunos datos básicos sobre tu espacio?
          </span>
          <div className="grid grid-cols-1 gap-5">
            {datos.map((d: any) => (
              <div className="flex justify-between items-center border-t-0 border-s-0 border-e-0 py-2  border-b-1 border border">
                <span className="font-bold">{d.name}</span>
                <div className="flex">
                  <label
                    className="cursor-pointer border w-[20px] h-[20px] flex border-black items-center justify-center"
                    style={{ borderRadius: "50%" }}
                  >
                    -
                    <button
                      className="hidden"
                      name={"menos-" + d.name}
                      onClick={(event) => onClick(event, d.name)}
                    ></button>
                  </label>

                  <input
                    type="text"
                    className="p-0 m-0 border-0 mx-2 w-[30px] h-[20px] text-center"
                    value={form[d.nameType]}
                  />

                  <label
                    className="cursor-pointer border w-[20px] h-[20px] flex border-black items-center justify-center"
                    style={{ borderRadius: "50%" }}
                  >
                    +
                    <button
                      className="hidden"
                      name={"mas-" + d.name}
                      onClick={(event) => onClick(event, d.name)}
                    ></button>
                  </label>
                </div>
              </div>
            ))}
          </div>
        </div>
        <div></div>
      </div>
    </div>
  );
};

export default DatosBasicos;
